

























































import Vue from 'vue';
import { RoleService } from '@/services/RoleService';
import { RoleModel, RouteRegEx } from '@/types';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { ComponentHelper, MTablehelper, RouteHelpers } from '@/mixins';

export default Vue.extend({
  name: 'RoleManagement',
  mixins: [ComponentHelper, MTablehelper, RouteHelpers],
  data() {
    return {
      isLoading: false,
      pageIsLoading: true,
      roles: [],
      entraEnabled: false
    };
  },
  computed: {
    fields(): any[] {
      const baseFields: Array<{ key: string; sortable: boolean; label?: string }> = [
        {
          key: 'name',
          sortable: true
        },
        {
          key: 'description',
          sortable: true
        }
      ];

      if (this.entraEnabled) {
        baseFields.push({
          key: 'entraGroupIdEnabled',
          label: 'Entra Group Mapping Enabled',
          sortable: true
        });
      }

      baseFields.push({
        key: 'actions',
        label: '',
        sortable: false
      });

      return baseFields;
    }
  },
  methods: {
    async initialise(this: any) {
      this.pageIsLoading = true;
      await this.getRolesAsync();
      this.resetFilters();
      this.pageIsLoading = false;
    },
    async getRolesAsync(this: any) {
      try {
        this.isLoading = true;
        const rolesResponse = await RoleService.getRolesAsync();
        this.roles = rolesResponse.roles;
        this.entraEnabled = rolesResponse.entraEnabled;
        this.$store.commit('configurationStore/SET_ENTRA_ENABLED', rolesResponse.entraEnabled);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
    resetFilters(this: any) {
      const canKeepState = this.canKeepState(RouteRegEx.Role);
      if (!canKeepState) {
        this.resetMTableState();
      }
    },
    navigateToId(this: any, routeName: any, data: any = null, paramName: string = 'id') {
      if (data) {
        const value = paramName === 'id' ? data : data.id;
        this.onTableStateFieldUpdated('selectedPk', value);
      }
      this.navigateToRoute(routeName, data, paramName);
    },
    isBuiltInRole(this: any, role: RoleModel): boolean {
      return role.id <= 0;
    }
  },
  mounted() {
    this.initialise();
  },
  components: {
    MStoreTable,
    LoadingSpinner
  }
});
